import React from 'react';
import './TestimonialsSection.scss';

const TestimonialsSection = () => {
  const testimonial = {
    quote: 'If you are looking to pick up shifts and make extra $$$, this app is the place to go.',
    name: 'Jim L',
    title: 'Athletic Trainer',
  };

  return (
    <section id="testimonials" className="testimonials-section scroll-animate fade-in">
      <article className="testimonial scroll-animate scale-up stagger-1">
        <blockquote className="testimonial__quote">&ldquo;{testimonial.quote}&rdquo;</blockquote>
        <cite className="testimonial__attribution">
          {testimonial.name}, {testimonial.title}
        </cite>
      </article>
    </section>
  );
};

export default TestimonialsSection;
